import { ref, onUnmounted, Ref } from 'vue';
import {
  ref as firebaseRef,
  onValue,
  off,
  DataSnapshot,
} from 'firebase/database';
import { db } from '../configs/firebase';

// todo check if global state is needed like in usePeerGlobally.ts
export function useRealtimeDatabaseList<T>(path: string) {
  const items = ref<T[] | null>(null); // The array is now typed as T[]
  const isLoading = ref(true);
  const error = ref<Error | null>(null);
  const listRef = firebaseRef(db, path);

  // Listener callback
  const valueChange = (snapshot: DataSnapshot) => {
    try {
      items.value = [];
      snapshot.forEach((childSnapshot) => {
        const item = childSnapshot.val();
        if (item) {
          items.value?.push(item);
          isLoading.value = false;
        }
      });
    } catch (err) {
      error.value = err as Error;
      isLoading.value = false;
    } finally {
      isLoading.value = false;
    }
  };

  // Subscribe to the list
  onValue(listRef, valueChange);

  // Unsubscribe when the component that uses this composable is unmounted
  onUnmounted(() => {
    off(listRef, 'value', valueChange);
  });

  return {
    items: items as Ref<T | null>,
    isLoading,
    error,
  };
}
